var UserMainEditController = (function () {
    function UserMainEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.email = '';
        this.user = {};
        this.userLoaded = false;
        this.email = $stateParams.user;
        //Listener for the user profile
        this.socket.forward('config.userbyemail', this.$scope);
        this.$scope.$on('socket:config.userbyemail', function (event, data) {
            _this.user = data;
            _this.userLoaded = true;
        });
    }
    UserMainEditController.prototype.$onInit = function () {
        //Get the Country Profiles
        //this.admin.getCountryConfig();
        //Get the General settings
        //this.admin.getGeneralConfig();
        //Get the User Profile
        this.admin.getUserProfile(this.email);
    };
    UserMainEditController.prototype.getAvatar = function () {
        if (this.user) {
            return this.DTS.getAvatar(this.user.email, 115);
        }
        return '';
    };
    UserMainEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', 'settings'];
    return UserMainEditController;
}());
var UserMainEditComponent = (function () {
    function UserMainEditComponent() {
        this.templateUrl = 'user-main.html';
        this.controllerAs = 'vm';
        this.controller = UserMainEditController;
    }
    return UserMainEditComponent;
}());
angular
    .module('application')
    .component('adminUserMainSection', new UserMainEditComponent());

//# sourceMappingURL=user-main.edit.component.js.map
